import clsx from 'clsx';
import type React from 'react';

import styles from './FileIllustration.module.css';

export interface FileProps {
    /** Color style for the file type */
    color: string;
    /** Text to display on the file */
    text: string;
    /** Class name for the file */
    className?: string;
}

/**
 * A file icon component with a folded corner effect.
 * Displays text on a colored background with a 3D folded corner.
 */
export function FileIllustration(props: FileProps): React.ReactElement {
    const { color, text, className } = props;

    return (
        <div
            className={clsx(
                'relative flex h-9 w-7 items-end justify-start rounded-sm border border-control bg-muted p-0 pb-0.5 pl-0.5 dark:bg-base',
                styles.file,
                className
            )}
        >
            <span className="text-[0.35rem] leading-none font-bold uppercase" style={{ color }}>
                {text}
            </span>
        </div>
    );
}
